export const environment = {
  production: false,
  environmentName: 'ACP',
  apiUrl: 'https://acp-upsprint-api.br.scania.com/api/'
};
